var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"text-sm",attrs:{"value":_vm.site,"clearable":false,"searchable":false,"get-option-label":function (site) { return site.name; },"options":_vm.sites},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }